import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import React, { useEffect } from 'react';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
import { useSmsSubstitutes } from '../hooks/use-sms-substitutes';
export interface SubstitutesBlockProps {
  inModal?: boolean;
}
export const SmsSubstitutesBlock = t0 => {
  const $ = _c(21);
  const {
    inModal
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [buttonAs, setButtonAs] = React.useState("div");
  const {
    substitutionData,
    isReady
  } = useSmsSubstitutes();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setButtonAs("button");
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = inModal && "border border-text-secondary/30 rounded-lg";
  let t4;
  if ($[2] !== t3) {
    t4 = twJoin(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t("dashboard.sms.available_substitutes.tooltip");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("dashboard.email.available_substitutes.title");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <b className="text-text-primary text-start text-[17px]">{t6}</b>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <Hint label={t5}>{t7}</Hint>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isReady || $[14] !== substitutionData) {
    t9 = isReady ? <ul className="flex flex-col gap-3">{substitutionData.map(_temp)}</ul> : <EmailSubstitutesSkeleton />;
    $[13] = isReady;
    $[14] = substitutionData;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== buttonAs || $[17] !== t4 || $[18] !== t8 || $[19] !== t9) {
    t10 = <DisclosureBox buttonAs={buttonAs} buttonClassName="cursor-pointer" wrapperClassName={t4} title={t8}>{t9}</DisclosureBox>;
    $[16] = buttonAs;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
const EmailSubstitutesSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse flex-col gap-3"><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div><div className="bg-skeleton-primary rounded-sm text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(el) {
  return <li key={el.id} className="flex flex-wrap gap-1"><span className="text-danger whitespace-nowrap">{el.id}</span>-<span>{el.caption}</span></li>;
}